import { observer } from 'mobx-react';
import React from 'react';

import TableToolbar from '../../shared/tableToolbar';
import AMACalculationRuleStore from './Store';

import * as api from '../../../stores/api';

@observer
class AMACalculationRuleToolbar extends React.Component {
  handleSearchChange = (_, { value }) => {
    AMACalculationRuleStore.setFieldsValue({ keyword: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    AMACalculationRuleStore.refetch({}, true);
  };

  handleReset = () => {
    AMACalculationRuleStore.resetStore();
  };

  handleCreate = () => {
    AMACalculationRuleStore.setPercentages([]);
    return AMACalculationRuleStore.toggleModal(true, { modalType: 'create' })();
  };

  openModalAddCalculationRule = () => {
    return AMACalculationRuleStore.toggleModal(true, {
      modalType: 'addCalculationRule',
    });
  };

  render() {
    const { keyword, loading } = AMACalculationRuleStore;
    return (
      <TableToolbar.Container>
        <TableToolbar.Left onSubmit={this.handleSubmit}>
          <TableToolbar.Input
            placeholder="Search"
            value={keyword}
            onChange={this.handleSearchChange}
            disabled={loading}
          />
          <TableToolbar.SubmitButton disabled={loading}>Search</TableToolbar.SubmitButton>
          <TableToolbar.HighLightButton
            className="negative"
            disabled={loading}
            onClick={this.handleReset}
            style={{ marginLeft: '5px' }}
          >
            Clear
          </TableToolbar.HighLightButton>
        </TableToolbar.Left>
        <TableToolbar.Right>
          {api.isAdmin() && (
            <TableToolbar.HighLightButton className="positive" disabled={loading} onClick={this.handleCreate}>
              Add Rule
            </TableToolbar.HighLightButton>
          )}
          {api.isAdminOrMagStaffOrAccounting() && (
            <TableToolbar.HighLightButton
              className="positive"
              disabled={loading}
              onClick={this.openModalAddCalculationRule()}
              style={{ marginLeft: 5 }}
            >
              Add Applicable Ranges
            </TableToolbar.HighLightButton>
          )}
        </TableToolbar.Right>
      </TableToolbar.Container>
    );
  }
}

export default AMACalculationRuleToolbar;
